import { IconPropTypes } from '@/legacy/types';

const HomeIcon = ({ width, height, color, className }: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width || 16}
			height={height || 16}
			fill='none'
			className={className}
		>
			<g
				stroke={color || 'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.143}
				clipPath='url(#a)'
			>
				<path d='M14.5 7.94a.999.999 0 0 0-.32-.74L8 1.5 1.82 7.2a1 1 0 0 0-.32.74v5.56a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V7.94ZM8 14.5v-4' />
			</g>
			<defs>
				<clipPath id='a'>
					<path
						fill='#fff'
						d='M0 0h16v16H0z'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default HomeIcon;
